import Link from 'next/link'
import { clsx } from 'clsx'
import { Eyebrow } from './Eyebrow'

interface SectionHeaderProps {
  children: React.ReactNode
  /** Optional "view all" link on the right. */
  actionLabel?: string
  actionHref?: string
  className?: string
}

/**
 * Editorial divider between content groups — an eyebrow label with an optional
 * quiet "view all" link. No box, no rule; rhythm does the separating.
 */
export function SectionHeader({ children, actionLabel, actionHref, className }: SectionHeaderProps) {
  return (
    <div className={clsx('flex items-center justify-between mb-3.5', className)}>
      <Eyebrow>{children}</Eyebrow>
      {actionLabel && actionHref && (
        <Link
          href={actionHref}
          className="text-[13px] font-semibold text-text-muted hover:text-text-primary transition-colors"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  )
}
